"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AllowanceContractInput = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_hook_form_1 = require("react-hook-form");
const mui_inputs_entity_1 = require("@dzambalaorg/mui-inputs-entity");
const AllowanceContractInput = (props) => {
    const { autoSelect, readOnly, disableClear, name, onChange, controller = "contracts", data = {}, withTokenType = false, } = props;
    const form = (0, react_hook_form_1.useFormContext)();
    const tokenType = (0, react_hook_form_1.useWatch)({ name: "tokenType" });
    return ((0, jsx_runtime_1.jsx)(mui_inputs_entity_1.ComboEntityInput, { name: name, controller: controller, data: { ...data, ...(withTokenType ? { contractType: [tokenType] } : {}) }, onChange: onChange ? onChange(form) : undefined, autoSelect: autoSelect, readOnly: readOnly, disableClear: disableClear }));
};
exports.AllowanceContractInput = AllowanceContractInput;
//# sourceMappingURL=index.js.map